import ItemActions from './ItemActions'

import Constants from './Constants'
import NotifyActions from './NotifyActions'

const STATUS = Constants.GET_USERS_STATUS
const GET = Constants.GET_USERS
const GET_ONE = Constants.GET_USER
const ADD = Constants.ADD_USER
const REMOVE = Constants.REMOVE_USER
const UPDATE = Constants.UPDATE_USER

const notify = {
  create : true,
  add : true,
  remove : true,
  update : true
}

function list( opts ) {
  return function( dispatch, getState, api ) {

    dispatch( { type : STATUS, status : Constants.STATUS_LOADING, statusMessage : null } )

    return api.users().list( opts )
      .then( ( data ) => {
        dispatch( { 
          type : GET,
          startIndex : data.startIndex,
          total : data.total,
          perPage : data.perPage, 
          items : data.items,
          search : data.search
        } )
        return data
      } )
      .catch( ( x ) => {
        dispatch( NotifyActions.requestError( 'Failed to get Users', x ) )
        dispatch( { type : STATUS, status : Constants.STATUS_ERROR } )
      } )
  }
}

function create( item ) {
  return function( dispatch, getState, api ) {
    return api.users().create( item )
      .then( ( data ) => {
        dispatch( { type : ADD, item : data } )
        notify.create && dispatch( NotifyActions.success( 'Successfully Created User', data.name || data.id ) )
        return data
      } )
      .catch( ( err ) => { dispatch( NotifyActions.requestError( 'Failed to Create User', err ) ) } )
  }
}

function get( item, opts ) {
  return function( dispatch, getState, api ) {
    const req = api.user( item ).get( opts )
    return req
      .then( ( data ) => {
        dispatch( { type : GET_ONE, item : data } )
        return data
      } ).catch( ( err ) => { dispatch( NotifyActions.requestError( 'Failed to Get User', err ) ) } )
  }
}

function remove( item ) {
  return function( dispatch, getState, api ) {
    const req = api.user( item ).delete()
    return req
      .then( ( data ) => {
        dispatch( { type : REMOVE, itemId : typeof item === 'string' ? item : item.id } )
        notify.remove && dispatch( NotifyActions.success( 'Successfully Removed User', data.name || data.id ) )
        return data
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( 'Failed to Remove User', err ) )
      } ) 
  }
}

function update( item, patchOps, opts ) {
  return function( dispatch, getState, api ) {
    const req = api.user( item ).update( patchOps, opts )
    return req
      .then( ( data ) => {
        dispatch( { type : UPDATE, item : data } )
        console.log( item, 'test' )
        notify.update && dispatch( NotifyActions.success( 'Successfully Updated User', data.name || data.id ) )
        return data
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( 'Failed to Update User', err ) )
      } ) 
  }
}

module.exports = { 
  list, 
  create,
  get,
  remove,
  update
}
